import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import AddUpdateUnitCard from "../Card/AddUpdateUnitCard";
import { useTemplateFontSettings } from "styles/templateFontSettings";


function AddUpdateUnitDialog({ onClose, open, afterUpdateFunc, selectedUnit, addAfterTable }) {
    const { titleSize, lineHeight } = useTemplateFontSettings();
    return (
        <Dialog onClose={onClose} open={open} fullWidth maxWidth="lg">
            <DialogTitle style={{ fontSize: titleSize, lineHeight: lineHeight }}>{selectedUnit ? 'Kurul/Kol/Komisyon Güncelle' : 'Kurul/Kol/Komisyon Ekle'}</DialogTitle>
            <DialogContent dividers>
                <AddUpdateUnitCard afterUpdateFunc={afterUpdateFunc} selectedUnit={selectedUnit} onClose={onClose} addAfterTable={addAfterTable} />
            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>
    );
}

export default AddUpdateUnitDialog